import { ReactElement } from "react";
import { AppProviders } from "AppProviders";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import { store, persistor } from "redux/store";
import Router from "routes";
import "i18n/config";
import "assets/scss/app.scss";
import AlertHooks from "AlertHooks";
import AuthHooks from "AuthHooks";
import { GoogleOAuthProvider } from "@react-oauth/google";
import { CONFIGURATION } from "utils/constants";

// import './sass/main.scss';

const App = (): ReactElement => (
  <Provider store={store}>
    <GoogleOAuthProvider clientId={CONFIGURATION.auth.GoogleClientId}>
      <PersistGate persistor={persistor}>
        <AppProviders>
          <AuthHooks />
          <AlertHooks />
          <Router />
        </AppProviders>
      </PersistGate>
    </GoogleOAuthProvider>
  </Provider>
);

export default App;
